/* ZWIM SWOLF & efficiency tool — external (deferred). buildInputs() on unit change only; compute() on keystroke. */
(function(){
  var app=document.getElementById('ztf-app'); if(!app) return;
  var unit='m';
  var $=function(id){return document.getElementById(id);};
  function pt(v){v=(''+(v==null?'':v)).trim();if(!v)return 0;v=v.replace(/[.]/g,':');if(v.indexOf(':')<0)return parseFloat(v)||0;var p=v.split(':').map(function(x){return parseFloat(x)||0;});while(p.length<3)p.unshift(0);return p[0]*3600+p[1]*60+p[2];}
  function pace(s){if(!isFinite(s)||s<=0)return'--';var m=Math.floor(s/60),x=Math.round(s-m*60);if(x===60){m++;x=0;}return m+':'+(x<10?'0':'')+x;}
  var I='inputmode="decimal" autocomplete="off"';
  function setHero(big,cap,unitTxt){var b=$('ztf-big');$('ztf-cap').textContent=cap;$('ztf-bigunit').textContent=unitTxt;if(b.textContent!==big){b.textContent=big;b.classList.add('pulse');setTimeout(function(){b.classList.remove('pulse');},180);if(window.__zwimTrack)window.__zwimTrack('tool_calc_run',{tool:'swolf',unit:unit});}}
  function chips(arr){return '<div class="ztf__chips">'+arr.map(function(c){return '<div class="ztf__chip"><div class="k">'+c.k+'</div><div class="v" data-k="'+c.k+'">'+c.v+'</div></div>';}).join('')+'</div>';}
  var lastChips={};
  function setChips(ex,arr){
    ex.innerHTML=chips(arr);
    arr.forEach(function(c){
      if(lastChips[c.k]!==undefined&&lastChips[c.k]!==c.v){
        var el=ex.querySelector('.v[data-k="'+c.k+'"]');
        if(el)el.classList.add('pulse');
      }
      lastChips[c.k]=c.v;
    });
  }
  function buildInputs(){
    var inp=$('ztf-inputs');
    inp.innerHTML='<div class="ztf__f"><label>Pool length ('+unit+')</label><input id="i-len" value="25" '+I+'></div><div class="ztf__f"><label>Time for one length (sec)</label><input id="i-time" value="20" '+I+'></div><div class="ztf__f"><label>Strokes for that length</label><input id="i-str" value="16" '+I+'></div>';
    inp.querySelectorAll('input').forEach(function(e){e.addEventListener('input',compute);});
  }
  function compute(){
    var poolLen=+(($('i-len')||{}).value)||0, timeSec=pt(($('i-time')||{}).value), strokes=+(($('i-str')||{}).value)||0, ex=$('ztf-extra');
    if(poolLen>0&&timeSec>0&&strokes>0){
      var swolf=timeSec+strokes;
      var dps=poolLen/strokes;
      var strokeRate=strokes/(timeSec/60);
      var pace100=timeSec*(100/poolLen);
      setHero(''+Math.round(swolf),'Your SWOLF','lower = more efficient');
      setChips(ex,[
        {k:'Distance / stroke',v:dps.toFixed(2)+' '+unit},
        {k:'Stroke rate',v:Math.round(strokeRate)+' spm'},
        {k:'Pace /100'+unit,v:pace(pace100)}
      ]);
    } else {
      setHero('--','Your SWOLF','lower = more efficient');
      setChips(ex,[
        {k:'Distance / stroke',v:'--'},
        {k:'Stroke rate',v:'--'},
        {k:'Pace /100'+unit,v:'--'}
      ]);
    }
    $('ztf-hint').textContent="SWOLF rewards fewer strokes AND less time. But it can't tell you if those strokes actually produce propulsion.";
  }
  function bindGroup(id,set){$(id).querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){$(id).querySelectorAll('button').forEach(function(x){x.classList.remove('on');x.setAttribute('aria-selected','false');});b.classList.add('on');b.setAttribute('aria-selected','true');set(b);});});}
  bindGroup('ztf-unit', function(b){ unit=b.getAttribute('data-unit'); buildInputs(); compute(); });
  buildInputs(); compute();
})();
